export default __webpack_public_path__ + "images/79ec9023598876c40fe0bacc85aa8ae5.png";